import dayjs from 'dayjs';

export const formatDate = (date?: string) => (date ? dayjs(date).format('YYYY-MM-DD') : '');

export const formatDateTime = (date?: string) =>
  date ? dayjs(date).format('YYYY-MM-DD HH:mm') : '';

export const formatDateTimeWithSeconds = (date?: string) =>
  date ? dayjs(date).format('YYYY-MM-DD HH:mm:ss') : '';
